import React, { Component } from 'react';
import { Link } from 'react-router';
import Tabs from 'react-tabs-navigation';
// import Modal from 'react-modal';
import { isLoaded } from 'react-redux-firebase';

import Loading from '../../../../components/elements/loading';
import PanelListItemDuo from '../../../../components/layout/panel-list-item-duo';
// import ConnectModuleMembersModalView from './modal-view';
// import ConnectModuleMembersModalAdd from './modal-add';
// import { modalStyle } from '../../../../components/layout/modal/modal-style';

/* eslint-disable */
export default class CoursesClassesClassView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false
    };
  }

  renderModules(modules) {
    return Object.keys(modules).map((id) => {
      return <PanelListItemDuo
            key={ id }
            // url={ '/courses/' + this.props.params.slug + '/classes/' + job }
            title={ modules[id].name }
            info={ modules[id].fromName } />;
    });

  }

  render() {
    var list;
    if (!isLoaded(this.props.class)) {
      return (
        <div className="panel-view connect">
          <Loading />
        </div>);
    }
    return (
      <div className="panel-view connect">
        <Tabs
          tabsBarClassName={
            "tabbar"
          }
          lineStyle={{
            backgroundColor: '#00aa96'
          }}
          banner={{
            children: () => (
              <section className="panel-view-header">
                <div className="view-header-center">
                  <h2>{ this.props.class.classID }</h2>
                  <h3>{ this.props.class.duration ? this.props.class.duration : "Duration" }</h3>
                </div>
                <div className="view-header-right">
                  <Link onClick={this.openModal}><i className="icon icon-settings" /></Link>
                </div>
              </section>
            )
          }}
          tabs={[
            {
              children: () => (
                <div>
                  <div className="panel-view-list">
                    <ul>
                      { this.props.class.modules &&
                        this.renderModules(this.props.class.modules)
                      }
                    </ul>
                  </div>
                  <section className="panel-view-footer">
                    <div className="panel-view-button-container">
                      <Link className="button turquoise">Add</Link>
                    </div>
                  </section>
                </div>
              ),
              displayName: 'Modules'
            },
            {
              children: () => (
                <div>
                  <div className="panel-view-list">
                    <ul>
                      <PanelListItemDuo
                        key={ 1 }
                        image="/assets/img/default-photo.png"
                        title="Max Mustermann"
                        info="ID" />
                    </ul>
                  </div>
                  <section className="panel-view-footer">
                    <div className="panel-view-button-container">
                      <Link className="button turquoise">Manage</Link>
                    </div>
                  </section>
                </div>
              ),
              displayName: 'Members'
            }
          ]}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/courses/classes/class/index.jsx